<template>
  <div style="display: inline-block">
    <slot></slot>
    <ConfirmDialog
      :dialogShow="rejectDialogShow"
      title="驳回理由"
      :showFooter="true"
      :width="800"
      @updateDialogShow="updateDialogShow"
      @confirm="confirm"
    >
      <div class="boxs-h">
        <el-checkbox-group v-model="checkList" class="boxs-c">
          <el-checkbox
            v-for="(item, index) in rejectList"
            :key="index"
            :label="item"
          />
        </el-checkbox-group>
        <el-input
          v-if="showInput"
          type="textarea"
          :rows="2"
          placeholder="请输入"
          v-model="textarea"
        >
        </el-input>
      </div>
    </ConfirmDialog>
  </div>
</template>
<script>
import ConfirmDialog from "@/components/ConfirmDialog";
export default {
  components: {
    ConfirmDialog,
  },
  watch: {
    checkList: {
      immediate: true,
      handler: function (value) {
        if (value.includes("其他")) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
      },
    },
  },
  methods: {
    openDialog() {
      this.rejectDialogShow = true;
    },
    closeDialog() {
      this.rejectDialogShow = false;
    },
    updateDialogShow(vis) {
      this.rejectDialogShow = vis;
    },
    confirm() {
      if (this.showInput) {
        this.$emit("confirm", this.checkList, this.textarea);
      } else {
        this.$emit("confirm", this.checkList);
      }
    },
  },
  data() {
    return {
      rejectDialogShow: false,
      showInput: false,
      checkList: [],
      textarea: "",
      rejectList: [
        // "请出具执照与许可证地址不一致情况说明（两证地址不同）",
        // "请出具执照与许可证名称不一致情况说明（两证名称不同）",
        // "企业名称及地址请按营业执照填写（按执照填写）",
        // "采购/收货人应与被委托人及身份证信息一致",
        // "收货地址需与执照 许可证一致",
        // "公章需与执照或许可证名称一致",
        // "委托书应为许可证法人签字（签字错误）",
        // "委托书请补充法人签字  签发日期（缺少签字、日期）",
        // "委托书签发日期请补充完整为2023年（签发日期不完整）",
        // "委托书请用黑色签字笔书写",
        // "请重新打印填写",
        // "查询到营业执照有变更，请提供最新版执照（执照有变更）",
        // "查询到药品证有变更，请提供药品证副本及变更记录复印件加盖公章（药品证有变更）",
        // "查询到许可证有变更，请提供副本及变更记录复印件加盖公章（许可证有变更）",
        // "委托书 营业执照 许可证 药品证 身份证复印件 盖章模糊",
        // "其他",
        "请出具执照与许可证/备案证地址不一致情况说明（两证地址不同）",
        "请出具执照与许可证/备案证名称不一致情况说明（两证名称不同）",
        "委托书最多跨一年",
        "全套需加盖同一个公章鲜章",
        "委托书授权人未签字",
        "授权委托书授权人信息应与平台采购/收货人信息一致",
        "其他",
      ],
    };
  },
};
</script>
<style scoped>
.boxs-c {
  display: flex;
  flex-flow: column;
  line-height: 30px;
}
.boxs-h {
  max-height: 600px;
  overflow: auto;
}
</style>